import { crudTable, date, index, integer, real } from "@-/dev.improve.haniverse.lib.database.table";
import { sql } from "@-/com.npmjs.drizzle-orm";

export const fsrsCardTable = crudTable(
  "fsrs_card",
  {
    difficulty: real("difficulty").notNull(), // Reflects the inherent difficulty of the card content
    due: date("due").notNull(),
    elapsedDays: integer("elapsed_days").notNull(), // Days since the card was last reviewed
    lapses: integer("lapses").notNull(), // Times the card was forgotten or remembered incorrectly
    lastReview: date("last_review"), // The most recent review date, if applicable
    learningSteps: integer("learning_steps").notNull(), // Keeps track of the current step during the (re)learning stages
    reps: integer("reps").notNull(), // Total number of times the card has been reviewed
    scheduledDays: integer("scheduled_days").notNull(), // The interval of time in days between this review and the next one
    stability: real("stability").notNull(), // A measure of how well the information is retained
    state: integer("state").notNull(), // The current state of the card (New, Learning, Review, Relearning)
  },
  // Partial index for the hot active-fsrs-card read (`deleted_at IS NULL`),
  // used by `actorQueries(…).fsrsCard.findMany` and the review-progress
  // due-count join. Without it, the soft-delete predicate forced a full
  // `SCAN fsrs_card` (~320ms on a populated deck); the partial index turns it
  // into an index scan even though most rows match.
  (table) => [
    index("fsrs_card_active_idx")
      .on(table.id)
      .where(sql`${table.deletedAt} is null`),
  ],
);

export type FsrsCard = typeof fsrsCardTable.$inferSelect;
